// 대시보드 카드 타입 정의
export const CARD_TYPES = {
  CURRENT_DISPATCH: 'currentDispatch',
  DR_HISTORY: 'drHistory',
  DR_LATEST_DISPATCH: 'drLatestDispatch',
  POWER_PRICE: 'powerPrice',
  DR_RESOURCE: 'drResource',
  EV_STATION: 'evStation',
  EV_CHARGER: 'evCharger',
  WEATHER: 'weather',
  CHARGING_DEMAND: 'chargingDemand',
  OPM_CONTRACT_SUMMARY: 'opmContractSummary',
};

// 카드 그룹 정의
export const CARD_GROUPS = {
  COMMON: 'common', // 공통 그룹
  DR_RELATED: 'drRelated', // DR 관련 그룹
  DISABLED_COMMON: 'disabledCommon', // 비활성화된 공통 그룹 (편집 모드에서만 표시)
  DISABLED_DR_RELATED: 'disabledDrRelated', // 비활성화된 DR 관련 그룹 (편집 모드에서만 표시)
};

// 카드 그룹별 허용 카드 타입
export const GROUP_ALLOWED_CARDS = {
  [CARD_GROUPS.COMMON]: [
    CARD_TYPES.CURRENT_DISPATCH,
    CARD_TYPES.DR_HISTORY,
    CARD_TYPES.POWER_PRICE,
  ],
  [CARD_GROUPS.DR_RELATED]: [
    CARD_TYPES.DR_RESOURCE,
    CARD_TYPES.DR_LATEST_DISPATCH,
    CARD_TYPES.EV_STATION,
    CARD_TYPES.EV_CHARGER,
    CARD_TYPES.WEATHER,
    CARD_TYPES.CHARGING_DEMAND,
    CARD_TYPES.OPM_CONTRACT_SUMMARY,
  ],
};

// 그리드 크기 (4열 기준)
export const GRID_COLUMNS = 4;

// 카드 기본 설정
// sizeW, sizeH: 그리드 단위 크기 (최소 1x1)
// x, y: 그리드 좌표 (1부터 시작, 왼쪽 상단이 (1,1))
export const CARD_DEFAULTS = {
  [CARD_TYPES.CURRENT_DISPATCH]: {
    id: CARD_TYPES.CURRENT_DISPATCH,
    type: CARD_TYPES.CURRENT_DISPATCH,
    group: CARD_GROUPS.COMMON,
    enabled: true,
    sizeW: 1,
    sizeH: 1,
    x: 1,
    y: 1,
    order: 0,
  },
  [CARD_TYPES.DR_HISTORY]: {
    id: CARD_TYPES.DR_HISTORY,
    type: CARD_TYPES.DR_HISTORY,
    group: CARD_GROUPS.COMMON,
    enabled: true,
    sizeW: 1,
    sizeH: 1,
    x: 2,
    y: 1,
    order: 1,
  },
  [CARD_TYPES.POWER_PRICE]: {
    id: CARD_TYPES.POWER_PRICE,
    type: CARD_TYPES.POWER_PRICE,
    group: CARD_GROUPS.COMMON,
    enabled: true,
    sizeW: 2,
    sizeH: 1,
    x: 3,
    y: 1,
    order: 3,
  },
  [CARD_TYPES.DR_RESOURCE]: {
    id: CARD_TYPES.DR_RESOURCE,
    type: CARD_TYPES.DR_RESOURCE,
    group: CARD_GROUPS.DR_RELATED,
    enabled: true,
    sizeW: 1,
    sizeH: 1,
    x: 1,
    y: 1,
    order: 0,
  },
  [CARD_TYPES.EV_STATION]: {
    id: CARD_TYPES.EV_STATION,
    type: CARD_TYPES.EV_STATION,
    group: CARD_GROUPS.DR_RELATED,
    enabled: true,
    sizeW: 1,
    sizeH: 1,
    x: 2,
    y: 1,
    order: 1,
  },
  [CARD_TYPES.EV_CHARGER]: {
    id: CARD_TYPES.EV_CHARGER,
    type: CARD_TYPES.EV_CHARGER,
    group: CARD_GROUPS.DR_RELATED,
    enabled: true,
    sizeW: 1,
    sizeH: 1,
    x: 3,
    y: 1,
    order: 2,
  },
  [CARD_TYPES.DR_LATEST_DISPATCH]: {
    id: CARD_TYPES.DR_LATEST_DISPATCH,
    type: CARD_TYPES.DR_LATEST_DISPATCH,
    group: CARD_GROUPS.DR_RELATED,
    enabled: true,
    sizeW: 1,
    sizeH: 1,
    x: 1,
    y: 2,
    order: 2,
  },
  [CARD_TYPES.WEATHER]: {
    id: CARD_TYPES.WEATHER,
    type: CARD_TYPES.WEATHER,
    group: CARD_GROUPS.DR_RELATED,
    enabled: true,
    sizeW: 1,
    sizeH: 3,
    x: 4,
    y: 1,
    order: 3,
  },
  [CARD_TYPES.CHARGING_DEMAND]: {
    id: CARD_TYPES.CHARGING_DEMAND,
    type: CARD_TYPES.CHARGING_DEMAND,
    group: CARD_GROUPS.DR_RELATED,
    enabled: true,
    sizeW: 3,
    sizeH: 2,
    x: 1,
    y: 2, // WEATHER 카드가 1-3행을 차지하므로 4행부터 시작
    order: 4,
  },
  [CARD_TYPES.OPM_CONTRACT_SUMMARY]: {
    id: CARD_TYPES.OPM_CONTRACT_SUMMARY,
    type: CARD_TYPES.OPM_CONTRACT_SUMMARY,
    group: CARD_GROUPS.DR_RELATED,
    enabled: true,
    sizeW: 1,
    sizeH: 1,
    x: 2,
    y: 3,
    order: 5,
  },
};

// 그룹 정보
export const GROUP_INFO = {
  [CARD_GROUPS.COMMON]: {
    id: CARD_GROUPS.COMMON,
    label: '공통 그룹',
  },
  [CARD_GROUPS.DR_RELATED]: {
    id: CARD_GROUPS.DR_RELATED,
    label: 'DR 그룹',
  },
  [CARD_GROUPS.DISABLED_COMMON]: {
    id: CARD_GROUPS.DISABLED_COMMON,
    label: '비활성화된 공통 그룹',
  },
  [CARD_GROUPS.DISABLED_DR_RELATED]: {
    id: CARD_GROUPS.DISABLED_DR_RELATED,
    label: '비활성화된 DR 그룹',
  },
};

